import React, { Component } from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import { Confirm } from "react-confirm-bootstrap";
import moment from "moment"
import {
  Button,
  FormControl,
  ControlLabel,
  FormGroup,
  Modal,
  Row,
  Table,
  Col
} from "react-bootstrap";

class GameTable extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      deleteDialog: false,
      modalShowing: false,
      editObj: { name: "", broadCastTime: "" }
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.handleEditChange = this.handleEditChange.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }
  componentDidMount(){
    console.log("Game Table component mounter");
    console.log(this.props.games);
  }
  handleEditChange(e, attribute) {
    const target = e.target;
    let temp = Object.assign({}, this.state.editObj);
    temp[attribute] = target.value;
    this.setState({ editObj: temp });
  }

  // outsideThis.setState({ result: [{ name: "ERROR" }] });
  handleDelete(obj) {
    this.props.onDelete(obj);
  }

  handleUpdate(e) {
    this.setState({ modalShowing: false });
    const editObj = this.state.editObj;
    editObj.broadCastTime = new Date();
    this.props.onUpdate(this.state.editObj);
  }

  render() {
    function Td({ children, to }) {
      const content = <Link to={to}>{children}</Link>;

      return <td className="id">{content}</td>;
    }

    const content =
      this.props.games.length === 0 ? (
        <tr>
          <td>No {this.props.objecttype} added</td>
          {this.props.attributes.map((attribute, index) => (
            <td key={index}>No {this.props.objecttype} added</td>
          ))}
        </tr>
      ) : (
        this.props.games.map((obj, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            {this.props.attributes.map((attribute, index) => {
              if (attribute === "broadCastTime")
                return (
                  <td key={index}>
                    <Moment>{obj[attribute]}</Moment>
                  </td>
                );
              else return <td key={index}>{obj[attribute]}</td>;
            })}
            <td>
              <Button
                style={{ marginRight: "10px" }}
                bsSize="small"
                bsStyle="default"
                onClick={() => {
                  const tempObj = Object.assign({}, obj);
                  const mom = moment(tempObj.broadCastTime);
                  tempObj.broadCastDate = mom.format("YYYY-MM-DD");
                  tempObj.timeOfBroadCast = mom.format("HH:MM");
                  this.setState({ modalShowing: true, editObj: tempObj });
                }
                }
              >
                Edit
              </Button>
              <Link to={`/games/${obj._id}/`}>
                <Button
                  style={{ marginRight: "10px" }}
                  bsSize="small"
                  bsStyle="info"
                >
                  VIEW
                </Button>
              </Link>
              <Confirm
                show={this.state.deleteDialog}
                onConfirm={() => this.handleDelete(obj)}
                body="Are you sure you want to delete this quiz?"
                confirmText="Confirm Delete"
                title="Delete Quiz"
              >
                <Button
                  style={{ marginRight: "10px" }}
                  bsSize="small"
                  bsStyle="danger"
                  onClick={() => this.setState({ deleteDialog: true })}
                >
                  DELETE
                </Button>
              </Confirm>
            </td>
          </tr>
        ))
      );

    return (
      <div className="content">
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>#</th>
              {this.props.attributes.map((attribute, index) => (
                <th key={index}>
                  {attribute === "broadCastTime" ? "Broadcast Time" : attribute}
                </th>
              ))}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{content}</tbody>
        </Table>

        <Modal
          show={this.state.modalShowing}
          onHide={() => this.setState({ modalShowing: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Quiz</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <FormGroup controlId="formBasicText">
                <Row>
                  <Col xs={6} md={4}>
                    <ControlLabel>Name</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.editObj.name}
                      placeholder="Enter the name of the game"
                      onChange={e => this.handleEditChange(e, "name")}
                    />
                  </Col>
                  <Col xs={6} md={4}>
                    <ControlLabel>Date</ControlLabel>
                    <FormControl
                      type="date"
                      value={this.state.editObj.broadCastDate}
                      placeholder="Enter the broadcast date of your game"
                      onChange={e => this.handleEditChange(e, "broadCastDate")}
                    />
                  </Col>
                  <Col xs={6} md={4}>
                    <ControlLabel>Time</ControlLabel>
                    <FormControl
                      type="time"
                      placeholder="Enter the broadcast time of your game"
                      onChange={e => this.handleEditChange(e, "timeOfBroadCast")}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.handleUpdate}>
              {" "}
              Update
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default GameTable;



// WEBPACK FOOTER //
// ./src/components/Table/GameTable.jsx